import styled from 'styled-components'

export const Container = styled.div`
    width: 950px;
    padding: 16px;
    background: #fff;
    border: solid 1px #707070;
    margin-bottom: 48px;
    margin-top: 12px;
`
export const PropertyDetailTitle = styled.h4`
    font-size: ${props => props.theme.fontSizes.md};
    margin: 0px;
    font-weight: bold;
`